export default __webpack_public_path__ + "static/media/pic_error_internet.1b176d39.svg";